import * as React from 'react';
import CenterOutlined from './center-outlined';
import CenterFilled from './center-filled';
import type { IconCombinedProps } from './types';
const CenterCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CenterFilled ref={ref} {...rest} />;
  }
  return <CenterOutlined ref={ref} {...rest} />;
});
export default CenterCombined;